























































import { ButtonType } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { computed, ref, defineComponent } from '@vue/composition-api';
import BankIdLogo from '../../../assets/bankid.svg';
import type { BankId } from '../../../types/bankid';
import { BankIdSigningType } from '../../../types/enums/bankid-se';

export default defineComponent({
  components: {
    BankIdLogo,
  },
  props: {
    bankId: {
      type: Object as PropType<BankId>,
      required: true,
    },
    jwt: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const type = ref<BankIdSigningType>(BankIdSigningType.None);

    const handleSetQR = () => {
      type.value = BankIdSigningType.QR;
      emit('setQR');
    };

    const handleSetSameDevice = () => {
      type.value = BankIdSigningType.SameDevice;
      emit('setSameDevice');
    };

    const qrIsLoading = computed(
      () => props.bankId.isLoading && type.value === BankIdSigningType.QR
    );

    const sameDeviceIsLoading = computed(
      () => props.bankId.isLoading && type.value === BankIdSigningType.SameDevice
    );

    return {
      ButtonType,
      type,
      handleSetQR,
      handleSetSameDevice,
      qrIsLoading,
      sameDeviceIsLoading,
    };
  },
});
